<template>
    <div>

    </div>
</template>

<script>
import axios from "axios";
import { Toast } from "vant"
import env from "../common/newapi/env"; // 引入环境变量配置文件
export default {
    components: {},
    data() {
        return {};
    },
    created() { },
    methods: {
        // 获取用户IP地址
        async fetchLocation() {
            return new Promise(async (resolve, reject) => {
                try {
                    // 模拟第一个 IP 服务失败
                    // throw new Error("模拟第一个 IP 服务失败");

                    // 尝试获取第一个 IP 地址
                    const resIp = await axios.get("https://api64.ipify.org?format=json");
                    if (resIp.data && resIp.data.ip) {
                        console.log("获取的 IP 地址:", resIp.data.ip);

                        // 调用百度地图 API 获取城市信息
                        const cityInfo = await this.getCityFromBaidu(resIp.data.ip);
                        if (cityInfo) {
                            resolve(cityInfo); // 成功获取城市信息
                            return;
                        }
                    }
                } catch (error) {
                    console.warn("第一个 IP 服务获取失败:", error.message || error);
                }

                try {
                    // 模拟第二个 IP 服务失败
                    // throw new Error("模拟第二个 IP 服务失败");

                    // 如果第一个服务失败，尝试获取第二个 IP 地址
                    const ipdata2 = await axios.get("https://ipinfo.io/json");
                    if (ipdata2.data && ipdata2.data.ip) {
                        console.log("备用服务获取的 IP 地址:", ipdata2.data.ip);

                        // 调用百度地图 API 获取城市信息
                        const cityInfo = await this.getCityFromBaidu(ipdata2.data.ip);
                        if (cityInfo) {
                            resolve(cityInfo); // 成功获取城市信息
                            return;
                        }
                    }
                } catch (error) {
                    console.warn("第二个 IP 服务获取失败:", error.message || error);
                }

                // 如果所有服务都失败，返回默认值
                console.warn("所有 IP 服务均失败，返回默认值 '360'");
                return "360"; // 默认值
            });
        },

        // 调用百度地图 API 获取城市信息
        async getCityFromBaidu(ip) {
            try {
                // throw new Error("模拟调用第一种百度地图服务方法失败");
                // 第一种方法：通过 JSONP 调用百度地图 API
                const res = await this.$jsonp("https://api.map.baidu.com/location/ip", {
                    ip: ip, // 动态获取用户 IP
                    ak: "El0QeVsZC5lSMW3LCYS47fe75P5OMk1w", // 百度地图密钥
                    coor: "bd09ll", // 坐标类型
                    output: "json", // 输出格式
                });

                // 检查返回结果
                if (res.status === 0 && res.content.address_detail.city) {
                    console.log("JSONP 获取的城市信息:", res.content.address_detail.city);
                    return res.content.address_detail.city; // 返回城市信息
                }
            } catch (err) {
                console.error("第一种方法调用百度地图 API 失败:", err.message || err);
            }

            try {
                // 准备请求参数
                const data = {
                    ip: ip, // 动态获取用户 IP
                    ak: "El0QeVsZC5lSMW3LCYS47fe75P5OMk1w", // 百度地图密钥
                    coor: "bd09ll", // 坐标类型
                };
                // 判断环境，选择代理路径
                const proxyUrl =
                    process.env.NODE_ENV === "development"
                        ? `/api/baidu` // 本地测试环境
                        : `${env.prod.baseUrl}/api-baidu`; // 正式环境

                // 使用后端代理调用百度地图 API
                const response = await axios.get(proxyUrl, { params: data });

                // 检查返回结果
                if (response.data.status === 0 && response.data.content.address_detail.city) {
                    console.log("备用获取的城市信息:", response.data.content.address_detail.city);
                    return response.data.content.address_detail.city; // 返回城市信息
                }

                // 未查询到城市信息
                // this.showToast("未查询到城市信息");
                console.error("后端代理调用百度地图API未查询到城市信息:");
                return "360";
            } catch (err) {
                // 捕获错误并提示
                console.error("备用调用百度地图 API 失败:", err.message || err);
                // this.showToast("地势查询失败");
                return "360";
            }

        },

        // 封装 Toast 提示
        showToast(message) {
            Toast({
                position: "bottom",
                message: message,
                duration: 800, // 单位 ms
            });
        }
    },
    computed: {},
    watch: {},
    mounted() { },
};
</script>

<style scoped lang='scss'></style>